// import { useEffect, useState } from "react";
// import {
//   Button,
//   Flex,
//   Modal,
//   message,
//   Table,
//   Input,
//   Spin,
//   Popconfirm,
// } from "antd";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   SearchOutlined,
//   UsbOutlined,
// } from "@ant-design/icons";
// import {
//   postComportConfiguration,
//   putComportConfiguration,
//   deleteComportConfiguration,
//   fetchComportConfiguration,
// } from "../Service/comportConfiguration";
// import ComportConfigurationForm from "./ComportConfigurationForm";

// let searchTimeout = null;

// const ComportConfiguration = () => {
//   const [comportConfigurations, setComportConfigurations] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [page, setPage] = useState(1);
//   const [size, setSize] = useState(10);
//   const [search, setSearch] = useState(undefined);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const [sortField, setSortField] = useState("createdDate");
//   const [sortOrder, setSortOrder] = useState("descend");

//   // ================= FETCH =================
//   const fetchData = async (
//     pageNum = page,
//     pageSize = size,
//     searchText = search,
//     field = sortField,
//     order = sortOrder
//   ) => {
//     setLoading(true);
//     try {
//       const res = await fetchComportConfiguration({
//         page: pageNum - 1,
//         size: pageSize,
//         search: searchText || "",
//         sort: field,
//         desc: order === "descend",
//       });
//       // setComportConfigurations(res.data?.content || []);

//       setComportConfigurations(res.data || []);
//       setTotal(res.data?.totalElements || 0);
//       setPage(pageNum);
//       setSize(pageSize);
//       setSortField(field);
//       setSortOrder(order);
//     } catch {
//       message.error("Network error while fetching device types");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= SAVE =================
//   const saveData = async (data) => {
//     setLoading(true);
//     try {
//       if (editData) {
//         await putComportConfiguration(data, editData.uuid);
//       } else {
//         await postComportConfiguration(data);
//       }
//       messageApi.success(
//         `Comport Configuration ${editData ? "updated" : "added"} successfully`
//       );
//       handleCancel();
//       fetchData();
//     } catch {
//       messageApi.error("Error while saving device type");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= DELETE =================
//   const deleteData = async (id) => {
//     try {
//       await deleteComportConfiguration(id);
//       messageApi.success("Comport Configuration deleted successfully");
//       fetchData();
//     } catch {
//       messageApi.error("Error while deleting device type");
//     }
//   };

//   const handleCancel = () => {
//     fetchData();
//     setIsModalOpen(false);
//     setEditData(null);
//   };

//   // ================= SEARCH (DEBOUNCE) =================
//   useEffect(() => {
//     clearTimeout(searchTimeout);
//     searchTimeout = setTimeout(() => {
//       fetchData(1, size, search);
//     }, 500);

//     return () => clearTimeout(searchTimeout);
//   }, [search]);

//   // ================= INIT =================
//   useEffect(() => {
//     fetchData();
//   }, []);

//   // ================= COLUMNS =================
//   const columns = [
//     {
//       title: "Port",
//       dataIndex: "port",
//       key: "port",
//       sorter: true,
//       sortOrder: sortField === "port" ? sortOrder : null,
//     },
//     {
//       title: "Baud Rate",
//       dataIndex: "baudRate",
//       key: "baudRate",
//       sorter: true,
//       sortOrder: sortField === "baudRate" ? sortOrder : null,
//     },
//     {
//       title: "Data Bits",
//       dataIndex: "dataBits",
//       key: "dataBits",
//       sorter: true,
//       sortOrder: sortField === "dataBits" ? sortOrder : null,
//     },
//     {
//       title: "Parity",
//       dataIndex: "parity",
//       key: "parity",
//       sorter: true,
//       sortOrder: sortField === "parity" ? sortOrder : null,
//     },
//     {
//       title: "Flow Control",
//       dataIndex: "flowControl",
//       key: "flowControl",
//       sorter: true,
//       sortOrder: sortField === "flowControl" ? sortOrder : null,
//     },
//     {
//       title: "Stop Bits",
//       dataIndex: "stopBits",
//       key: "stopBits",
//       sorter: true,
//       sortOrder: sortField === "stopBits" ? sortOrder : null,
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       align: "center",
//       render: (_, record) => (
//         <>
//           <EditOutlined
//             style={{ marginRight: 12, cursor: "pointer" }}
//             onClick={() => {
//               setEditData(record);
//               setIsModalOpen(true);
//             }}
//           />
//           {/* <DeleteOutlined
//             style={{ cursor: "pointer" }}
//             onClick={() => deleteData(record.uuid)}
//           /> */}
//           <Popconfirm
//             title="Delete comport settings"
//             description="Are you sure you want to delete this comport settings?"
//             okText="Yes"
//             cancelText="No"
//             placement="left"
//             onConfirm={() => deleteData(record.uuid)}
//           >
//             <DeleteOutlined style={{ cursor: "pointer", color: "red" }} />
//           </Popconfirm>
//         </>
//       ),
//     },
//   ];

//   return (
//     <Spin spinning={loading}>
//       <div style={{ width: "100%" }}>
//         {contextHolder}

//         <Flex
//           justify="space-between"
//           align="center"
//           style={{ marginBottom: 16 }}
//         >
//           <div style={{ fontSize: "1rem", fontWeight: 700 }}>
//             Comport Configuration
//           </div>

//           <Flex gap={8}>
//             <Input
//               placeholder="Search"
//               prefix={<SearchOutlined />}
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//             <Button type="primary" onClick={() => setIsModalOpen(true)}>
//               Add
//             </Button>
//           </Flex>
//         </Flex>

//         <Table
//           rowKey="id"
//           columns={columns}
//           dataSource={comportConfigurations}
//           bordered
//           pagination={{
//             current: page,
//             pageSize: size,
//             total,
//             showSizeChanger: true,
//           }}
//           scroll={{ x: "max-content" }}
//           onChange={(pagination, filters, sorter) => {
//             const field = sorter.field || sortField;
//             const order = sorter.order || sortOrder;

//             fetchData(
//               pagination.current,
//               pagination.pageSize,
//               search,
//               field,
//               order
//             );
//           }}
//         />

//         <Modal
//           title={<span>{editData ? "Edit " : "Add "}port configuration</span>}
//           centered
//           open={isModalOpen}
//           footer={false}
//           onCancel={handleCancel}
//         >
//           <ComportConfigurationForm editData={editData} saveData={saveData} />
//         </Modal>
//       </div>
//     </Spin>
//   );
// };

// export default ComportConfiguration;

import { useEffect, useState } from "react";
import { Button, Flex, Modal, message, Table, Input, Spin, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import {
  postComportConfiguration, putComportConfiguration,
  deleteComportConfiguration, fetchComportConfiguration,
} from "../Service/comportConfiguration";
import ComportConfigurationForm from "./ComportConfigurationForm";
import usePermission from "../../../../../hooks/usePermission";

let searchTimeout = null;

const ComportConfiguration = () => {
  const { canCreate, canUpdate, canDelete } = usePermission("QUALITY_COMPORT");

  const [comportConfigurations, setComportConfigurations] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [search, setSearch] = useState(undefined);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("descend");

  const fetchData = async (pageNum = page, pageSize = size, searchText = search, field = sortField, order = sortOrder) => {
    setLoading(true);
    try {
      const res = await fetchComportConfiguration({ page: pageNum - 1, size: pageSize, search: searchText || "", sort: field, desc: order === "descend" });
      setComportConfigurations(res.data || []);
      setTotal(res.data?.totalElements || 0);
      setPage(pageNum); setSize(pageSize); setSortField(field); setSortOrder(order);
    } catch { message.error("Network error while fetching comport configurations"); }
    finally { setLoading(false); }
  };

  const saveData = async (data) => {
    setLoading(true);
    try {
      if (editData) { await putComportConfiguration(data, editData.uuid); }
      else { await postComportConfiguration(data); }
      messageApi.success(`Comport Configuration ${editData ? "updated" : "added"} successfully`);
      handleCancel(); fetchData();
    } catch { messageApi.error("Error while saving comport configuration"); }
    finally { setLoading(false); }
  };

  const deleteData = async (id) => {
    try {
      await deleteComportConfiguration(id);
      messageApi.success("Comport Configuration deleted successfully");
      fetchData();
    } catch { messageApi.error("Error while deleting comport configuration"); }
  };

  const handleCancel = () => { setIsModalOpen(false); setEditData(null); };

  useEffect(() => { fetchData(); }, []);
  useEffect(() => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => fetchData(1, size, search), 500);
    return () => clearTimeout(searchTimeout);
  }, [search]);

  const columns = [
    { title: "Port", dataIndex: "port", key: "port", sorter: true, sortOrder: sortField === "port" ? sortOrder : null },
    { title: "Baud Rate", dataIndex: "baudRate", key: "baudRate", sorter: true },
    { title: "Data Bits", dataIndex: "dataBits", key: "dataBits", sorter: true },
    { title: "Parity", dataIndex: "parity", key: "parity", sorter: true },
    { title: "Flow Control", dataIndex: "flowControl", key: "flowControl", sorter: true },
    { title: "Stop Bits", dataIndex: "stopBits", key: "stopBits", sorter: true },
    {
      title: "Actions", key: "actions", align: "center",
      render: (_, record) => (
        <>
          {canUpdate && (
            <EditOutlined style={{ marginRight: 12, cursor: "pointer" }} onClick={() => { setEditData(record); setIsModalOpen(true); }} />
          )}
          {canDelete && (
            <Popconfirm title="Delete comport settings" description="Are you sure?" okText="Yes" cancelText="No" placement="left" onConfirm={() => deleteData(record.uuid)}>
              <DeleteOutlined style={{ cursor: "pointer", color: "red" }} />
            </Popconfirm>
          )}
        </>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ width: "100%" }}>
        {contextHolder}
        <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
          <div style={{ fontSize: "1rem", fontWeight: 700 }}>Comport Configuration</div>
          <Flex gap={8}>
            <Input placeholder="Search" prefix={<SearchOutlined />} value={search} onChange={(e) => setSearch(e.target.value)} />
            {canCreate && <Button type="primary" onClick={() => setIsModalOpen(true)}>Add</Button>}
          </Flex>
        </Flex>
        <Table rowKey="id" columns={columns} dataSource={comportConfigurations} bordered scroll={{ x: "max-content" }}
          pagination={{ current: page, pageSize: size, total, showSizeChanger: true }}
          onChange={(pagination, _, sorter) => fetchData(pagination.current, pagination.pageSize, search, sorter.field || sortField, sorter.order || sortOrder)}
        />
        <Modal title={<span>{editData ? "Edit " : "Add "}port configuration</span>} centered open={isModalOpen} footer={false} onCancel={handleCancel}>
          <ComportConfigurationForm editData={editData} saveData={saveData} />
        </Modal>
      </div>
    </Spin>
  );
};

export default ComportConfiguration;